<template>
    <mini-button-full class="button-container p5" @click.native="showOptionsModal"
                      :disabled="isProductDisabled"
                      data-testid="showOptionsModal"
    >
      <span :class="[qtyInCart ? 'non-empty' : 'empty']" >
        <i class="material-icons" style="width: 24px; height: 24px; overflow: hidden;">shopping_cart</i>
      </span>
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </mini-button-full>
</template>

<script>
import { formatProductMessages } from '@vue-storefront/core/filters/product-messages'
import focusClean from 'theme/components/theme/directives/focusClean'
import { AddToCart } from '@vue-storefront/core/modules/cart/components/AddToCart'

const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');

export default {
  mixins: [AddToCart],
  directives: { focusClean },
  components: { MiniButtonFull },
  methods: {
    showOptionsModal () {
      this.$bus.$emit('modal-show', `modal-custom-options-${this.product.sku}`)
    }
  },
  computed: {
    isProductDisabled () {
      return this.disabled || formatProductMessages(this.product.errors) !== '' || this.isAddingToCart
    },
    cartItem () {
        return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    }
  },
  beforeMount () {
      this.$bus.$on('product-after-removevariant', this.onAfterRemovedVariant)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-removevariant')
  }
}
</script>

<style lang="scss" scoped>

    .button-container {
        border: 2px solid rgb(67, 176, 42);
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgb(67, 176, 42);
        opacity: 1;
        max-width: 34px;
        height: 34px;
        color: #fff;
        justify-content: center;

        &:hover {
            background-color: #fff;
            color: rgb(67, 176, 42);
        }

        i.material-icons {
            vertical-align: bottom;
            font-size: 20px;
        }
    }

    .spinner {
        display: none;
        animation: rotate 2s linear infinite;
        z-index: 2;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -15px 0 0 -15px;
        width: 30px;
        height: 30px;

        & .path {
            stroke: rgb(67, 176, 42);;
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

    .disabled {
        div.spinner {
            display: block;
        }

        img {
            display: none;
        }
    }

    @keyframes scale {
        0% {
            transform: scaleY(0);
        }
        50% {
            transform: scaleY(1);
        }
        100% {
            transform: scaleY(0);
        }
    }

</style>
<style>
    .product-listing .product {
        position: relative;
    }
</style>
